'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchOuterToInner = exports.panelVisibleToSide = exports.closeDialog = exports.createDialog = exports.DIALOG = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = info;
exports.isLoaded = isLoaded;
exports.load = load;
exports.setUiProps = setUiProps;
exports.upload = upload;

var _auth = require('./auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-example/LOAD';
var LOAD_SUCCESS = 'redux-example/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-example/LOAD_FAIL';

var UPLOAD = 'redux-example/UPLOAD';
var UPLOAD_SUCCESS = 'redux-example/UPLOAD_SUCESS';
var UPLOAD_FAIL = 'redux-example/UPLOAD_FAIL';

var SETUIPROPS = 'redux-example/SETUIPROP';

var MULTICHANGE = 'redux-exampleAGAMA_MULTI';
var DYNAMIC = 'redux-example/AGAMA_DYNAMIC';
var DIALOG = exports.DIALOG = 'agama/DIALOG';

var initialState = {
  loaded: false
};

function infoOne() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case UPLOAD:
      return (0, _extends3.default)({}, state, {
        uploading: true
      });
    case UPLOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        uploading: false,
        uploaded: false,
        error: action.error
      });
    case UPLOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        uploading: false,
        uploaded: true
      });
    case SETUIPROPS:
      var newState = (0, _extends3.default)({}, state, { data: (0, _extends3.default)({}, state.data, { ui: (0, _extends3.default)({}, state.data.ui) })
      });
      if (newState.data.ui[action.data.name] === action.data.value) {
        // console.log('stejné: ' + action.data.name + '= ' + action.data.value);
        return state;
      }
      newState.data.ui[action.data.name] = action.data.value;
      return newState;
    case DYNAMIC:
      var newState2 = action.changeState(state);
      return newState2;
    case DIALOG:
      return (0, _extends3.default)({}, state, {
        dialog: action.dialog
      });
    case _auth.LOGOUT_SUCCESS:
    case _auth.LOGIN_SUCCESS:
      var newStateLogin = (0, _extends3.default)({}, state, { data: (0, _extends3.default)({}, state.data, { ui: (0, _extends3.default)({}, state.data.ui) })
      });
      if (!newStateLogin.data.ui['loginMenuOpened']) {
        // console.log('stejné: ' + action.data.name + '= ' + action.data.value);
        return state;
      }
      delete newStateLogin.data.ui['loginMenuOpened'];
      return newStateLogin;

    default:
      return state;
  }
}

// obalena puvodni funkce infoOne, tak abych mohla volat více akcí na jednou.
function info() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (action.type === MULTICHANGE) {
    var newState = state;
    action.data.forEach(function (subAction) {
      newState = infoOne(newState, subAction);
    });
    return newState;
  }
  return infoOne(state, action);
}

function isLoaded(globalState) {
  return globalState.info && globalState.info.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/loadInfo');
    }
  };
}

function setUiProps(keyValueObjectOrKeyOnly, value) {
  var data = value == null ? keyValueObjectOrKeyOnly : { name: keyValueObjectOrKeyOnly, value: value }; // eslint-disable-line eqeqeq
  return {
    type: SETUIPROPS,
    data: data
  };
}

var createDialog = exports.createDialog = function createDialog(dialog) {
  return {
    type: DIALOG,
    dialog: dialog
  };
};
var closeDialog = exports.closeDialog = function closeDialog() {
  return {
    type: DIALOG
  };
};

var saveLastVisibleState = function saveLastVisibleState(panelInfo) {
  var name = panelInfo.name,
      childPanelName = panelInfo.childPanelName,
      mySide = panelInfo.mySide;
  // console.log('ukladam stav z reducera: ' + info.ui[(parentPanelName || name) + 'Z'] + ',' + info.ui[(childPanelName || name) + 'Z']);

  var propName = name + 'LastStateBeforeHiddenTo' + mySide;
  var propName2 = name + 'Display';
  var propName3 = childPanelName + 'Display';
  var propName4 = childPanelName + 'Z';
  var propName5 = name + 'Z';

  return {
    type: DYNAMIC,
    changeState: function changeState(state) {
      var newValue = [state.data.ui[name + 'Z'], state.data.ui[childPanelName + 'Z']];
      var newValue2 = 'pushed ' + mySide;
      var newValue3 = 'pushed ' + mySide;
      var newValue4 = 'top';
      var newValue5 = 'sub';

      if (newValue === state.data.ui[propName] && newValue2 === state.data.ui[propName2] && newValue3 === state.data.ui[propName3] && newValue4 === state.data.ui[propName4] && newValue5 === state.data.ui[propName5]) return state;
      var newState = (0, _extends3.default)({}, state, { data: (0, _extends3.default)({}, state.data, { ui: (0, _extends3.default)({}, state.data.ui) })
      });
      newState.data.ui[propName] = newValue;
      newState.data.ui[propName2] = newValue2;
      newState.data.ui[propName3] = newValue3;
      newState.data.ui[propName4] = newValue4;
      newState.data.ui[propName5] = newValue5;
      return newState;
    }
  };
  // setUiProps({
  //   name: (parentPanelName || name) + 'LastStateBeforeHiddenTo' + mySide,
  //   value: [info.ui[(parentPanelName || name) + 'Z'], info.ui[(childPanelName || name) + 'Z']]
  // });
};

var panelVisibleToSide = exports.panelVisibleToSide = function panelVisibleToSide(panelInfo) {
  // const {name/* jmeno panelu, který chceme ovladat */,
  // // parentPanelName /* jmeno nadrazeneho panelu nebo NULL*/,
  // // childPanelName /* jmeno podrazeneho panelu nebo NULL*/,
  // // mySide /* strana panelu - zda panel je levý nebo pravý*/} = panelInfo;
  // console.log('xxxxx0');
  var data = [];
  // if (parentPanelName) { // neni potreba asi
  //   data.push(setUiProps({
  //     name: parentPanelName + 'Z',
  //     value: 'sub'
  //   }));
  //   data.push(setUiProps({
  //     name: name + 'Z',
  //     value: 'top'
  //   }));
  //   data.push(setUiProps({
  //     name: name + 'Display',
  //     value: 'semiPushed ' + mySide
  //   }));
  // } else
  // {
  // console.log('xxxxx');
  data.push(saveLastVisibleState(panelInfo));
  // data.push(setUiProps({
  //   name: name + 'Display',
  //   value: 'pushed ' + mySide
  // }));
  // data.push(setUiProps({
  //   name: name + 'Z',
  //   value: 'sub'
  // }));
  // if (childPanelName) {
  //   data.push(setUiProps({
  //     name: childPanelName + 'Display',
  //     value: 'pushed ' + mySide
  //   }));
  //   // data.push(setUiProps({
  //   //   name: childPanelName + 'Z',
  //   //   value: 'sub'
  //   // }));
  // }
  // }
  return {
    type: MULTICHANGE,
    data: data
  };
};

var switchOuterToInner = exports.switchOuterToInner = function switchOuterToInner(panelInfo) {
  var name = panelInfo.name,
      childPanelName = panelInfo.childPanelName;

  var propName4 = childPanelName + 'Z';
  var propName5 = name + 'Z';
  return {
    type: DYNAMIC,
    changeState: function changeState(state) {
      var newValue4 = 'top';
      var newValue5 = 'sub';
      // console.log(state.data.ui[propName4] + state.data.ui[propName5]);
      if (state.data.ui[propName4] === state.data.ui[propName5]) return state;
      if (newValue4 === state.data.ui[propName4] && newValue5 === state.data.ui[propName5]) return state;
      var newState = (0, _extends3.default)({}, state, { data: (0, _extends3.default)({}, state.data, { ui: (0, _extends3.default)({}, state.data.ui) })
      });
      newState.data.ui[propName4] = newValue4;
      newState.data.ui[propName5] = newValue5;
      return newState;
    }
  };
};

// todo: zatim se nepouziva a mozna ani nefunguje
function upload(data) {
  return {
    types: [UPLOAD, UPLOAD_SUCCESS, UPLOAD_FAIL],
    promise: function promise(client) {
      alert(data);
      var stack = new Error().stack;
      console.log('PRINTING CALL STACK');
      console.log(stack);
      return client.get('/uploadInfo');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/info.js
// module id = 31
// module chunks = 0